import { useNodeStyle } from "@/components/expression/utils/NodeStyleProvider";
import { twMerge } from "@/utils/twMerge";

import type { ComponentProps, ComponentPropsWithoutRef, ElementType } from "react";

export type PolymorphicProps<E extends ElementType> = ComponentPropsWithoutRef<E> & {
  as?: E;
};

type NodeGroupProps = {
  expanded?: boolean;
} & ComponentProps<"div">;

/**
 * TODO: reduce nesting in groups. This component is probably not needed at all.
 * https://linear.app/corca-research/issue/D-1432/reduce-nesting-in-groups
 *
 * `NodeGroup` adjusts padding and layout based on the node's `size` and `view` style,
 * which are derived from the `useNodeStyle` hook. Used in `GroupNode` and `FunctionNode`'s parameters
 */
function NodeGroup({ className, children, expanded, ...props }: NodeGroupProps) {
  const { view, size } = useNodeStyle();

  return (
    <div
      className={twMerge(
        "flex flex-nowrap justify-center items-center",

        size === "sm" && "py-0.5 px-1.5",
        size === "xs" && "p-0.5 px-1.25",
        size === "xxs" && "p-0.5 px-1.25",

        size === "sm" && expanded && "p-1.5",
        size === "xs" && expanded && "p-1",

        view === "text" && "p-0",
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
}

export { NodeGroup as Group };
